
export const SHOW_OVERLAY = 'SHOW_OVERLAY'
export const CLOSE_OVERLAY = 'CLOSE_OVERLAY'



// WEBPACK FOOTER //
// ./src/containers/Engine/containers/Overlay/actionTypes.js